import { render, staticRenderFns } from "./CenterCard.vue?vue&type=template&id=44563660&scoped=true"
import script from "./CenterCard.vue?vue&type=script&lang=js"
export * from "./CenterCard.vue?vue&type=script&lang=js"
import style0 from "./CenterCard.vue?vue&type=style&index=0&id=44563660&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44563660",
  null
  
)

export default component.exports